export function resolveAuthApiUrl(path: string): string {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  const apiOrigin = process.env.API ?? '';

  if (typeof window !== 'undefined') {
    const apiUrl = new URL(apiOrigin || window.location.origin, window.location.origin);
    if (apiUrl.hostname === window.location.hostname) {
      return normalizedPath;
    }
  }

  return `${apiOrigin}${normalizedPath}`;
}
